import React from 'react';

export default function IconEStatement() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_674_33375)">
        <path
          d="M18.375 18.2372C18.375 18.9718 17.7795 19.5672 17.045 19.5672H7.705C6.97046 19.5672 6.375 18.9718 6.375 18.2372V5.8925C6.375 5.15796 6.97046 4.5625 7.705 4.5625H13.0417L18.375 10.0745V18.2372Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.0396 10.0745H18.3729L13.0396 4.5625V10.0745Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_674_33375">
          <rect
            width="18"
            height="18"
            fill="white"
            transform="translate(3.375 3.06445)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
